<template>
  <div class="bg-black h-full flex flex-col flex-grow">
    <header
      class="
        header-student header
        absolute
        left-0
        right-0
        top-0
        overflow-visible
        opacity-90
        text-white
        px-3
        z-30
        transition-all
        bg-header-grey
        duration-300
        border border-t-0 border-strong-grey
        rounded-b-xl
        ease-in-out
      "
      :class="{ active: headerActive }"
    >
      <SessionHeader
        :headerActive="headerActive"
        :toggleHeader="toggleHeader"
        :hideChatBtn="true"
      />
    </header>
    <div class="flex">
      <div class="flex flex-col flex-grow">
        <main class="relative my-6">
          <CanJoinConsultationOverlay
            v-if="session.late_entry && entryDenied === false"
            :session="session"
            :user="user"
          />
          <CannotJoinConsultationOverlay v-else :session="session" />
        </main>

        <SessionFooter
          :jitsiRoom="null"
          :defaultDevices="[]"
          class="border border-grey border-b-0 rounded-t-2xl"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useSetupSessionData } from '@/Composables/useSetupSessionData';

import { VICE_SESSION_PHASES } from '@/Utils/vice-constants';
import DateFormatMixinVue from '@/Mixins/DateFormatMixin.vue';
import SessionHeader from '@/Components/Session/Header/SessionHeader.vue';
import SessionFooter from '@/Components/Session/Footer/SessionFooter.vue';
import CanJoinConsultationOverlay from '@/Components/Session/Overlays/CanJoinConsultationOverlay.vue';
import CannotJoinConsultationOverlay from '@/Components/Session/Overlays/CannotJoinConsultationOverlay';

export default {
  components: {
    SessionFooter,
    SessionHeader,
    CanJoinConsultationOverlay,
    CannotJoinConsultationOverlay,
  },
  mixins: [DateFormatMixinVue],
  props: {
    entryDenied: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const headerActive = ref(true);
    const { sessionStore, session, authUser } = useSetupSessionData();

    const toggleHeader = () => {
      headerActive.value = !headerActive.value;
    };

    return {
      session,
      headerActive,
      sessionStore,
      toggleHeader,
      user: authUser,
      VICE_SESSION_PHASES,
    };
  },
};
</script>

<style lang="scss" scoped>
.header {
  height: 96px;
}

.header-student {
  top: 0;
  left: 0;
  width: auto;
  color: #fff;
  transform: translateY(-85%);
}

.header-student.active {
  transform: translateY(0);
}

main {
  min-height: 100vh;
  height: 100vh;

  .grid.gap-0 {
    width: calc((100vh - 88px) * 1.777777);
    margin: 0 auto;
  }
}

#preview-section {
  height: 332px;

  .camera {
    min-width: 430px;
  }

  .preview-right {
    min-width: 430px;
  }
}

.footer {
  height: 96px;
}
</style>
